<select #comboBox [style.width.px]="width" [style.width]="width !== undefined ? width : '100%'"
  [(ngModel)]="selectedDnaDiv" (change)="updateBindedField($event);onChange($any($event.target).value);" (blur)="onTouched()"
  [tabindex]="tabindex" [hidden]="!visible" [disabled]="disabled">
  <ng-template ngFor let-item [ngForOf]="model.codeList" let-i="index">
    <option value="{{item.DnaDiv}}">{{item.DnaDivName}}</option>
  </ng-template>
</select>
